export const TIER_1_COUNTRY = ["SOM", "ETH", "KEN", "MAR", "MOZ", "SEN"];
export const TIER_2_COUNTRY = [
  "ALB", // Albania
  "ARM", // Armenia
  "AGO", // Angola
  "BDI", // Burundi
  "CRI", // Costa Rica
  "SLV", // El Salvador
  "GTM", // Guatemala
  "NIC", // Nicaragua
  "PHL", // Philippines
  "TUN", // Tunisia
  "UGA", // Uganda
  "ZMB", // Zambia;
];
